module.exports = __webpack_public_path__ + "img/The-Good-Logo.f40946b9.png";